<button pButton
    [class.pn-settled]="settled()"
    [class.ghost]="variant() === 'ghost'"
    [class.link]="variant() === 'link'"
    [class.icon-pos-top]="iconPos() === 'top'"
    [class.icon-pos-bottom]="iconPos() === 'bottom'"
    [severity]="severity()"
    [type]="type()"
    [size]="size()"
    [disabled]="disabled() || actionPending() || isLoading()"
    [attr.aria-busy]="isLoading() || null"
    [fluid]="fluid()"
    [rounded]="rounded()"
    [text]="variant() === 'text' || variant() === 'link'"
    [outlined]="variant() === 'outlined'"
    (click)="handleClick($event)"
>
    @if (isLoading()) {
        <pn-icon name="loader-circle" [size]="resolvedIconSize()" class="pn-button-spinner" pButtonIcon></pn-icon>
    } @else if (icon() && iconPos() !== 'right' && iconPos() !== 'bottom') {
        <pn-icon [name]="icon()!" [size]="resolvedIconSize()" pButtonIcon></pn-icon>
    }
    @if (text()) {
        <span pButtonLabel>{{ text() }}</span>
    }
    @if (!isLoading() && icon() && (iconPos() === 'right' || iconPos() === 'bottom')) {
        <pn-icon [name]="icon()!" [size]="resolvedIconSize()" pButtonIcon></pn-icon>
    }
</button>
